var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"registerUser fill-height",attrs:{"fluid":""}},[_c('v-row',{staticClass:"registerUser__register",attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"8"}},[_c('Register')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }